import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

export const COMUNICADOS_ADMIN_QK = ['comunicados-admin'];
export const FEED_QK = ['comunicados', 'feed'];
export const UNREAD_QK = ['comunicados', 'unread-count'];

type SaveBody = {
  title?: string;
  body_html?: string;
  body_json?: unknown;
  embed_urls?: string[];
  is_published?: boolean;
};

function bustAll(qc: ReturnType<typeof useQueryClient>): void {
  qc.invalidateQueries({ queryKey: COMUNICADOS_ADMIN_QK });
  qc.invalidateQueries({ queryKey: FEED_QK });
  qc.invalidateQueries({ queryKey: UNREAD_QK });
}

export function useCreateComunicado() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (body: SaveBody) =>
      pb.send<{ id: string }>('/api/comunicados', { method: 'POST', body }),
    onSuccess: () => {
      bustAll(qc);
      toast('Comunicado creado', 'success');
    },
    onError: () => toast('Error al crear', 'error'),
  });
}

export function useUpdateComunicado() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (v: { id: string; body: SaveBody }) =>
      pb.send<{ id: string }>(`/api/comunicados/${v.id}`, {
        method: 'PATCH',
        body: v.body,
      }),
    onSuccess: (_d, v) => {
      bustAll(qc);
      qc.invalidateQueries({ queryKey: ['comunicado', v.id] });
      toast('Comunicado actualizado', 'success');
    },
    onError: () => toast('Error al actualizar', 'error'),
  });
}

export function useDeleteComunicado() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (id: string) =>
      pb.send(`/api/comunicados/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      bustAll(qc);
      toast('Comunicado eliminado', 'success');
    },
    onError: () => toast('Error al eliminar', 'error'),
  });
}
